import React, { useState, useEffect } from "react";
import MaterialTable from "material-table";
import {
    MuiThemeProvider,
    createMuiTheme,
    makeStyles,
    createStyles,
} from "@material-ui/core/styles";
import { timeDurationToTime } from "../../utilities/utility";
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControl, Grid, IconButton, TextField } from "@material-ui/core";
import { checkUserAccess, db, getCheckSession } from "../../apis/auth";
import { addDoc, collection, doc, getDocs, orderBy, query, updateDoc } from "firebase/firestore";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import CloseIcon from "@material-ui/icons/Close";
import { format } from "date-fns";
import { getDataFromAPICall, getHistoryFromAPICall, handleSave } from "../../query/config.query";
import { NotificationManager } from "react-notifications";


export const ILMFirmware = () => {

    const classes = useStyles();
    const [ILMData, setILMData] = useState([]);
    const [isOpenDialog, setIsOpenDialog] = useState(false);
    const [ILMDialog, setILMDialog] = useState({ url: "", sha: "", ver: 0 });
    const [ILMDocId, setILMDocId] = useState(null);
    const history = useHistory();
    const [historyDialog, setHistoryDialog] = useState(false);
    const [historyData, setHistoryData] = useState([]);
    const [formErrors, setFormErrors] = useState({});

    useEffect(async () => {
        console.log("========== LiveMeterFeed : OnInit() ==========");
        var sessionStatus = await getCheckSession();
        if (sessionStatus === false) {
            history.push("/");
            return;
        }
        getILMInfo();
    }, []);

    const getILMHistory = () => {
        getHistoryFromAPICall("fw_upd_hist_ilm")
            .then((historyList) => {
                // alert(JSON.stringify(historyList))
                setHistoryData(historyList);
                setHistoryDialog(true)
            })
            .catch(() => {
                NotificationManager.error("Unable to fetch ILM history", "", 3000);
            });
    }

    const getILMInfo = () => {
        getDataFromAPICall("fw_updates",'ilm')
            .then((result) => {
                const { docId, configInfo } = result;
                setILMDocId(docId);
                setILMDialog(configInfo)
                setILMData(configInfo)
            })
            .catch(() => {
                NotificationManager.error("Unable to fetch ILM data", "", 3000);
            });
    }
    const handleSelectedDate = (data, field) => {
        let { target: { value = "" } = {} } = data;
        setILMDialog((prevState) => ({
            ...prevState,
            [field]: value
        }));
    };
    const handleEdit = () => {
        setIsOpenDialog(true);
    };

    const getScheduledTime = () => {
        const { url = "", sha = "", ver = "" } = ILMData;
        return (
            <Grid xs={6} sm={8}>
                <div style={{ padding: '5px', fontWeight: 'normal', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <span style={{ fontWeight: 'bold' }}>URL</span>
                    <span>{url}</span>
                </div>
                <div style={{ padding: '5px', fontWeight: 'normal', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <span style={{ fontWeight: 'bold' }}>SHA</span>
                    <span>{sha}</span>
                </div>
                <div style={{ padding: '5px', fontWeight: 'normal', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <span style={{ fontWeight: 'bold' }}>Version</span>
                    <span>{ver}</span>
                </div>
            </Grid>

        );
        // return `${onTime} - ${offTime}`;
    };
    var editSLC = checkUserAccess("edit_config")

    const handleClose = () => {
        setIsOpenDialog(false);
    };

    const getScheduleHistoryColumnList = () => {
        return [
            {
                title: 'Firmware URL',
                render: ({ url: url = 0 }) => {
                    if (url != 0) {
                        return url;
                    }
                    return 0;
                },
            },
            {
                title: 'SHA',
                render: ({ sha: sha = 0 }) => {
                    if (sha != 0) {
                        return sha;
                    }
                    return 0;
                },
            },
            {
                title: 'Version',
                render: ({ ver: ver = 0 }) => {
                    if (ver != 0) {
                        return ver;
                    }
                    return 0;
                },
            },
            {
                title: 'Modified By',
                render: ({ user: user = 0 }) => {
                    if (user != 0) {
                        return user;
                    }
                    return 0;
                },
            },
            {
                title: 'Date',
                render: ({ ch_dt: ch_dt = 0 }) => {
                    if (ch_dt != 0) {
                        return format(ch_dt.toDate(), "dd/MM/yyyy, hh:mm a");
                    }
                    return 0;
                },
            },
        ];
    };

    const validateForm = () => {
        const errors = {};
        if (!ILMDialog.url) {
            errors.url = 'Firmware URL is required';
        }
        if (!ILMDialog.sha) {
            errors.sha = 'SHA is required';
        }
        if (ILMDialog.url && !/^https?:\/\/[^\s$.?#].[^\s]*$/i.test(ILMDialog.url)) {
            errors.url = 'Invalid URL format';
        }
        setFormErrors(errors);
        return Object.keys(errors).length === 0;  // Returns true if no errors
    };

    const getSaveDisabledStatus = () => {
        const { ver, ...slcDialogWithoutVer } = ILMData;
        const { ver: ver1, ...slcDataWithoutVer } = ILMDialog;
        if (Object.keys(slcDialogWithoutVer).length !== Object.keys(slcDataWithoutVer).length) {
            return false;
        }
        return Object.entries(slcDialogWithoutVer).every(([key, value]) => slcDataWithoutVer[key] === value);
    };

    return (
        <div className="dim-schedule">
            <Grid container>
                <Grid xs={12} sm={12}>
                    <div className="settings-schedule-wrapper">
                        <h5 className="header">ILM Firmware
                        </h5>
                        <div style={{ padding: '10px' }}>{getScheduledTime()}</div>
                        <div className="edit-btn-wrapper">
                            <Button
                                variant="contained"
                                className="edit-btn"
                                onClick={() => {
                                    getILMHistory();
                                }}>
                                History
                            </Button>
                            {editSLC && <Button
                                variant="contained"
                                className="edit-btn"
                                onClick={() => {
                                    handleEdit();
                                }}>

                                Edit
                            </Button>}

                        </div>
                    </div>
                </Grid>

            </Grid>

            <Dialog
                className="change-schedule-dialog"
                onClose={handleClose}
                aria-labelledby="editTime-dialog-title"
                open={isOpenDialog}
                fullWidth
                PaperProps={{
                    component: 'form',
                    onKeyDown: (event) => {
                        if (event.key === 'Enter') {
                            event.preventDefault();
                        }
                    },
                    onSubmit: (event) => {
                        event.preventDefault();
                        if (validateForm()) {
                            handleSave(ILMDocId, ILMDialog, 'fw_updates','ilm').then(() => {
                                NotificationManager.success("Successfully save ilm firmware", "", 3000);
                                setIsOpenDialog(false);
                                getILMInfo();
                            }).catch(() => {
                                NotificationManager.error("Unable to update ilm firmware data", "", 3000);
                            })
                        }
                    },
                }}
            >
                <DialogTitle id="editTime-dialog-title" onClose={handleClose}>
                    ILM Firmware Phase 1
                    <IconButton
                        aria-label="close"
                        className={classes.closeButton}
                        onClick={handleClose}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent>
                    <FormControl className="dialog-form" style={{ width: '100%', margin: '0px 0' }}>
                        <TextField
                            autoFocus
                            margin="dense"
                            id="max voltage"
                            label="Firmware URL"
                            type="text"
                            onChange={(e) => handleSelectedDate(e, 'url')}
                            value={ILMDialog.url}
                            error={Boolean(formErrors.url)}
                            helperText={formErrors.url}
                        />
                    </FormControl>
                    <FormControl className="dialog-form" style={{ width: '100%', margin: '0px 0' }}>
                        <TextField
                            margin="dense"
                            id="min voltage"
                            label="SHA"
                            type="text"
                            onChange={(e) => handleSelectedDate(e, 'sha')}
                            value={ILMDialog.sha}
                            error={Boolean(formErrors.sha)}
                            helperText={formErrors.sha}
                        />
                    </FormControl>
                    <FormControl className="dialog-form" style={{ width: '100%', margin: '0px 0' }}>
                        <TextField
                            margin="dense"
                            id="Version"
                            label="Version"
                            type="number"
                            onWheel={(e) => {
                                e.target.blur();
                            }}
                            disabled
                            value={ILMDialog.ver + 1 || 1}
                        />
                    </FormControl>
                </DialogContent>
                <DialogActions>
                    <Button
                        className="save-btn"
                        type="submit"
                        disabled={getSaveDisabledStatus()}
                    >
                        Save
                    </Button>
                    <Button className="save-btn" onClick={handleClose}>
                        Cancel
                    </Button>
                </DialogActions>
            </Dialog>
            <Dialog className="history-dialog" open={historyDialog} onClose={() => { setHistoryDialog(false) }} aria-labelledby="form-dialog-title" fullWidth maxWidth={'md'}>
                <DialogTitle id="form-dialog-title">ILM History </DialogTitle>
                <DialogContent>

                    <MaterialTable
                        style={{
                            width: "100%",
                        }}
                        className={classes.table}
                        title={""}
                        columns={getScheduleHistoryColumnList()}
                        data={historyData}
                        options={{
                            exportButton: false,
                            search: false,
                            selection: false,
                            sorting: true,
                            pageSize: 5,
                            headerStyle: {
                                backgroundColor: "#0071CE",
                                color: "#FFF",
                                fontSize: "0.9em",
                                textAlign: "center",
                            },
                            actionsColumnIndex: -1,
                            emptyRowsWhenPaging: false,
                        }}
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => { setHistoryDialog(false) }} color="primary">
                        CLOSE
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}

const useStyles = makeStyles((theme) =>
    createStyles({
        button: {
            margin: theme.spacing(1),
        },
        table: {
            minWidth: 650,
        },
        root: {
            width: "100%",
        },
        formControl: {
            margin: theme.spacing(1),
            minWidth: 120,
            marginRight: 20,
        },
        selectEmpty: {
            marginTop: theme.spacing(2),
        },
        closeButton: {
            position: "absolute",
            right: theme.spacing(1),
            top: theme.spacing(1),
            color: theme.palette.grey[500],
        },
    })
);